export default {"src":"/_next/static/media/suitcase_24.2cc4b469.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};